export default {
    STARTUPS: 'startups',
    ECOSYSTEMS: 'ecosystems',
    ENTERPRISES: 'enterprises',
}
